// 🎯 Company-scoped role set. Distinct from the Sustina staff roles
// (GLOBALADMIN/SITEADMIN/SITEREADER/SITEUSER) used in SEC_03_Usermanagement —
// these apply only within a single CorporateEntity's ESG reporting workflow.
// Fixed literal codes backed by Corp.Z_02_CompanyUserRoleAssignment's CHECK
// constraint — not a dynamic RoleId lookup.
export const COMPANY_ROLES = [
  { code: "READER", label: "Reader" },
  { code: "APPROVER", label: "Approver" },
  { code: "MANAGER", label: "Manager" }
];

export const COMPANY_ROLE_CODES = COMPANY_ROLES.map((r) => r.code);

export const isCompanyRole = (roleCode) => COMPANY_ROLE_CODES.includes(roleCode);

export const companyRoleLabel = (roleCode) =>
  COMPANY_ROLES.find((r) => r.code === roleCode)?.label || roleCode;
